'use client'

import { useEffect } from 'react'
import { Noto_Sans_TC, Roboto } from 'next/font/google'
import { usePathname, useSelectedLayoutSegment } from 'next/navigation'
import { useAudio, useDevice, useError, useLiffToken, useLocation, useStation, useUser } from '@/app/store'
import OrientationPermission from '@/app/components/popup/OrientationPermission'
import LoadingIcon from '@/app/components/LoadingIcon'
import Transition from '@/app/components/Transition'
import Debug from '@/app/components/Debug'
import Error from '@/app/error'
import smoothscroll from 'smoothscroll-polyfill'
import classNames from 'classnames'
import '@/app/utils/api'
import '@/instrumentation-client'

const notoSans = Noto_Sans_TC({
    weight: ['300', '400', '500', '600', '700', '800'],
    subsets: ['latin'],
    variable: '--font-noto-sans'
})
const roboto = Roboto({
    weight: ['100', '300', '400', '500', '700', '900'],
    subsets: ['latin'],
    variable: '--font-roboto'
})

export default function PageLayout({children}: {children: React.ReactNode}) {
    
    const liffToken = useLiffToken()
    const user = useUser()
    const station = useStation()
    const audio = useAudio()
    const location = useLocation()
    const error = useError()
    const device = useDevice()
    const pathname = usePathname()
    const segment  = useSelectedLayoutSegment()
    const sentryEventId = error.sentryEventId
    const dataLoaded = liffToken.token && user?.data && station?.data

    useEffect(() => {
        liffToken.getToken()
        location.getGeoLocation()
        device.checkOrientationPermission()

        smoothscroll.polyfill()
        window.addEventListener('click', handleWindowClick, null)
    }, [])

    useEffect(() => {
        if (device.userInteraction) {
            audio.playMusic('/sounds/background.mp3')
        }
    }, [device.userInteraction])

    // useEffect(() => {
    //     if (liffToken.token) {
    //         console.log('📱 LIFF Token: ', liffToken.token)
    //     }
    // }, [liffToken.token])
    
    useEffect(() => {
        if (user.data) {
            console.log('🍹 User: ', user.data)
        }
    }, [user])

    useEffect(() => {
        if (station.data) {
            console.log('🗺️ Station: ', station)
        }
    }, [station])

    // useEffect(() => {
    //     if (location.geo?.data) {
    //         console.log('🧭 location: ', location.geo?.data)
    //     }
    // }, [location.geo?.data])

    // useEffect(() => {
    //     if (location.weather?.data) {
    //         console.log('🌤️ weather: ', location.weather?.data)
    //     }
    // }, [location.weather?.data])

    function handleWindowClick() {
        device.setUserInteraction(true)
        window.removeEventListener('click', handleWindowClick, null)
    }

    return (
        <>
        { dataLoaded &&
            <Transition transitionKey={segment} className="full">
            {/* <Transition transitionKey={pathname} className="full"> */}
                <div className={classNames('page-content', roboto.variable, notoSans.variable)}>
                    { children }
                </div>
            </Transition>
        }
        { !dataLoaded &&
            <div className="fixed top-0 left-0 full flex-center">
                <LoadingIcon text="資料讀取中" />
            </div>
        }
        { ['request', 'denied'].includes(device.orientationPermission) &&
            <OrientationPermission />
        }
        { sentryEventId && <Error id={sentryEventId} /> }
        <Debug />
        </>
    )
}
